export default [{
  scheme: [[[0, 0]], [[0, 0]], [[0, 0]]],
  isNewRow: true,
  id: 'empty_2',
}, {
  scheme: [[[0], [0, 0]]],
  isNewRow: true,
  id: 'empty_3',
}, {
  scheme: [[[0], [0, 0, 0], [0]]],
  isNewRow: true,
  id: 'empty_4',
}, {
  scheme: [[[0], [0, 0], [0, 0, 0, 0]]],
  isNewRow: true,
  id: 'empty_5',
}, {
  scheme: [[[0, 0], [0, 0, 0]]],
  isNewRow: true,
  id: 'empty_6',
}, {
  scheme: [[[0], [0, 0], [0, 0], [0]]],
  isNewRow: true,
  id: 'empty_7',
}, {
  scheme: [0, [[0], [0, 0, 0]]],
  isNewRow: true,
  id: 'empty_8',
}, {
  scheme: [0, [[0, 0], [0, 0], [0, 0], [0, 0]]],
  isNewRow: true,
  id: 'empty_9',
}, {
  scheme: [0, [[0], [0, 0, 0], [0]]],
  isNewRow: true,
  id: 'empty_10',
}, {
  scheme: [0, [[0, 0], [0, 0], [0, 0]]],
  isNewRow: true,
  id: 'empty_11',
}, {
  scheme: [[[0], [0], [0]], [[0], [0], [0]], [[0], [0], [0]]],
  isNewRow: true,
  id: 'empty_12',
}]



// WEBPACK FOOTER //
// ./src/view/left_sidebar/module/emptyTemplateConfig.js